import "./error.scss";

function ErrorFallback({ error, resetErrorBoundary }) {
	return (
		<div className="ef-container">
			<h2 className="ef-title">Something went wrong</h2>
			<p className="fw-bold">
				{error?.message || "An unexpected error occurred."}
			</p>
			<pre className="ef-pre">
				{error?.stack || String(error)}
			</pre>
			<button
				onClick={resetErrorBoundary}
				className="ef-retry-btn"
			>
				Try again
			</button>
		</div>
	);
}

export default ErrorFallback;
